const routeNames = {
  ForgotPassword: 'forgotpassword',
  ForgotPasswordConfirmation: 'forgotpassword-confirmation',
  Login: 'login',
  PasswordReset: 'passwordreset',
  ChargeBee: 'chargebee',
  ChargeBeePurchaseComplete: 'chargebee-purchase-complete',
  Signup: 'signup',
};

export default routeNames;
